import { Box, Container } from "@mui/material";
import Header from "./header";
import { Outlet, useLocation } from "react-router-dom";
import FloatingActionButton from "../components/FloatingActionButton";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

const Layout = () => {
  // Wait for Kinde auth to initialize
  const { isLoading } = useKindeAuth();

  // The admin section manages its own full-width layout (sidebar + content),
  // so it is not capped by the lg Container the public pages use.
  const location = useLocation();
  const isAdminSection = location.pathname.startsWith("/admin");

  // Sync user profile to Supabase on auth
  // useProfileSync();

  if (isLoading) {
    return <div>Loading authentication...</div>;
  }

  return (
    <Box>
      <Header />
      {isAdminSection ? (
        <Outlet />
      ) : (
        <Container maxWidth="lg">
          <Outlet />
        </Container>
      )}
      <FloatingActionButton />
    </Box>
  );
};

export default Layout;
